import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';

Vue.use(Vuex);

const initialParams = {
    is_new: false,
    category: false,
    platform: false,
    publisher: '',
    author: '',
    keywords: '',
    age: false,
    player: false,
    max_duration: false,
    language: '',
};

export default new Vuex.Store({
    state: {
        api: null,
        initialized: false,

        loading: false,
        results: [],
        pagination: {
            // total: null,
            // posts_per_page: null,
            // current_page: null,
            // total_pages: null,
            // from: null,
            // to: null,
        },

        config: null,

        params: {
            is_new: false,
            category: false,
            platform: false,
            publisher: '',
            author: '',
            keywords: '',
            age: false,
            player: false,
            max_duration: false,
        },
        query: '',
        previousQuery: null, // previous search term

        extendedFilterOpen: false,
    },
    mutations: {
        toggleExtendedFilter(state, on = null) {
            if (typeof on === 'boolean') {
                state.extendedFilterOpen = on;
            } else {
                state.extendedFilterOpen = !state.extendedFilterOpen;
            }

            if (state.extendedFilterOpen) {
                document.documentElement.classList.add('w-is-lockedscroll');
            } else {
                document.documentElement.classList.remove('w-is-lockedscroll');
            }
        },
        setConfig(state, config) {
            state.config = config;
        },
        update(state, data) {
            state.results = data.results;
            Vue.set(state, 'pagination', data.pagination);
            state.previousQuery = state.query;
        },
        updateParams(state, params) {
            state.params = params;
        },
        setQuery(state, query) {
            state.query = query;
        },
        resetParams(state) {
            const newParams = initialParams;
            newParams.query = state.params.query;
            state.params = newParams;
        },
        // setParam(state, payload) {
        //     state.params[payload.key] = payload.value;
        // },
        // removeParam(state, key) {
        //     state.params[key] = null;
        // },
    },
    actions: {
        gotoPage({ commit, state }, payload = {}) {
            const num = payload.num ?? 1;
            const hideFilter = payload.hideFilter ?? true;

            if (state.loading) return;

            if (num < 1 || num > state.pagination.total_pages) return;

            let url = state.api + 'search';

            const config = {
                method: 'GET',
                responseType: 'json',
                url,
                params: state.params,
            };

            config.params.query = state.query;

            if (state.query === state.previousQuery) {
                config.params.page = num;
            }

            state.loading = true;

            axios(config)
                .then((response) => {
                    commit('update', response.data);
                    state.loading = false;
                    state.initialized = true;
                    if (hideFilter) commit('toggleExtendedFilter', false);
                })
                .catch((error) => console.log(error));
        },
    },
    getters: {
        filterCount: (state) => {
            const compareParams = state.params;
            delete compareParams['query'];
            delete compareParams['page'];

            let count = 0;
            for (const [index, param] of Object.entries(compareParams)) {
                if (param !== initialParams[index]) count++;
            }
            return count;
        },
    },
});
